<template>
  <div id="custom-box">
    <div id="handle" style="display: none;">
      <div data-type="point" data-dir="left" class="point left"></div>
      <div data-type="point" data-dir="left-top" class="point left-top"></div>
      <div data-type="point" data-dir="top" class="point top"></div>
      <div data-type="point" data-dir="right-top" class="point right-top"></div>
      <div data-type="point" data-dir="right" class="point right"></div>
      <div data-type="point" data-dir="right-bottom" class="point right-bottom"></div>
      <div data-type="point" data-dir="bottom" class="point bottom"></div>
      <div data-type="point" data-dir="left-bottom" class="point left-bottom"></div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      customBox: null,
      dragConfig: {
        isdragging: false, //是否拖拽
        dragEl: null, //拖拽的元素
        mouse: { x: 0, y: 0 }, //鼠标位置
        dragOutable: false, //是否可以拖出纸张范围
        dragDoms: [], //可拖拽的元素数组
      },
      zoomConfig: {
        direction: null, //缩放方向
        startY: 0, //开始位置
        startX: 0, //开始位置
      },
      defaultDom: {
        domId: "",
        x: 0,
        y: 0,
        content: "",
        width: 0,
        height: 0,
        style: {},
        dataset: {},
      },
    }
  },
  mounted() { },
  methods: {
    init() {
      this.customBox = document.getElementById('custom-box');
      window.addEventListener("mousemove", this.onMouseMove);
      window.addEventListener("mouseup", this.onMouseUp);
    },
    onCheckChange(data) {
      // console.log("onCheckChange", data);
      // console.log("custom_box", [this.customBox]);
      if (data.checked) {
        this.insertField(data);
      } else {
        this.deleteField(data);
      }
    },
    onFieldDelete() {
      var select_field = this.customBox.querySelector('.is-select');
      if (!select_field) {
        this.$message.warning("请先选中自定义区域中的字段")
        return;
      }
      this.deleteField({ field: select_field.id });
    },
    insertField(data) {
      var dom = document.createElement('div');
      dom.id = data.field;
      dom.innerHTML = data.content;
      dom.style.border = "1px dashed #1682e6";
      dom.style.fontSize = "14px";
      dom.dataset.fontSize = 14;
      dom.dataset.type = "field";
      dom.onclick = this.onMouseClick;
      dom.onmousedown = this.onMouseDown;
      this.customBox.appendChild(dom);
      dom.style.width = (dom.offsetWidth + 2) + "px";
      dom.style.height = dom.offsetHeight + "px";
      this.dragConfig.dragDoms.push({
        ...this.defaultDom,
        domId: data.field,
        content: data.content,
        width: (dom.offsetWidth + 2),
        height: dom.offsetHeight,
        style: {
          fontSize: dom.style.fontSize,
        }
      });
      console.log("dom", [dom])
    },
    deleteField(data) {
      var field = this.customBox.querySelector('#' + data.field);
      if (field) {
        var handle = document.getElementById("handle");
        handle.style.display = "none";
        this.customBox.appendChild(handle);
        this.customBox.removeChild(field);
        var drag_dom_index = this.dragConfig.dragDoms.findIndex(x => x.domId == data.field);
        this.dragConfig.dragDoms.splice(drag_dom_index, 1);
      }
      this.$emit("remove-field", data.field);
    },
    onFontChange(type) {
      var select_field = this.customBox.querySelector('.is-select');
      if (!select_field) {
        this.$message.warning("请先选中自定义区域中的字段")
        return;
      }
      // console.log("onFontChange", type);
      console.log("onFontChange", [select_field]);
      if (type == "up") {
        select_field.dataset.fontSize = Number(select_field.dataset.fontSize) + 1;
      } else {
        if (select_field.dataset.fontSize > 12)
          select_field.dataset.fontSize = Number(select_field.dataset.fontSize) - 1;
      }
      select_field.style.fontSize = select_field.dataset.fontSize + "px";
      select_field.style.width = select_field.style.height = "";
      var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == select_field.id);
      if (select_field.offsetWidth > drag_dom.width) {
        drag_dom.width = (select_field.offsetWidth + 2);
        drag_dom.height = select_field.offsetHeight;
      }
      select_field.style.width = drag_dom.width + "px";
      select_field.style.height = drag_dom.height + "px";
    },
    //鼠标按下
    onMouseDown(e) {
      if (e.button != 0) return;

      // console.log("鼠标按下", e);
      if (e.target.dataset.type == "field") {
        this.dragConfig.dragEl = e.target;
        this.dragConfig.mouse.x = e.pageX;
        this.dragConfig.mouse.y = e.pageY;
        this.dragConfig.isdragging = true;
      }

      //缩放元素相关代码
      if (e.target.dataset.type == "point") {
        this.zoomConfig.startY = e.pageY;
        this.zoomConfig.startX = e.pageX;
        this.zoomConfig.direction = e.target.dataset.dir;
      }
    },
    //鼠标移动
    onMouseMove(e) {
      if (this.dragConfig.isdragging) {
        document.body.style.userSelect = "none"; //关闭鼠标选择文本的功能
        var drag_el = this.dragConfig.dragEl;
        var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.id);
        //新位置 - 旧位置 = 移动的值
        const moveX = e.pageX - this.dragConfig.mouse.x;
        const moveY = e.pageY - this.dragConfig.mouse.y;
        //得出元素移动后的新位置
        let newX = drag_dom.x + moveX;
        let newY = drag_dom.y + moveY;

        //domEl是否可以拖拽出父元素
        if (!this.dragConfig.dragOutable) {
          //左边界最大值为0
          if (drag_dom.x < 0) newX = 0;
          //右边界最大值 纸张宽度 - 拖拽元素宽度
          var right_max = this.customBox.clientWidth - drag_el.clientWidth - 2; //减去的 2 是边框
          if (drag_dom.x > right_max) newX = right_max;
          //上边界最大值为0
          if (drag_dom.y < 0) newY = 0;
          //下边界最大值 纸张高度 - 拖拽元素高度
          var bottom_max = this.customBox.clientHeight - drag_el.clientHeight - 2; //减去的 2 是边框
          if (drag_dom.y > bottom_max) newY = bottom_max;
        }

        //记录鼠标位置
        this.dragConfig.mouse.x = e.pageX;
        this.dragConfig.mouse.y = e.pageY;

        //更新拖拽元素位置
        drag_dom.x = newX;
        drag_dom.y = newY;

        //移动元素
        drag_el.style.left = drag_dom.x + 'px';
        drag_el.style.top = drag_dom.y + 'px';
      }
      if (this.zoomConfig.direction != null) {
        document.body.style.userSelect = "none"; //关闭鼠标选择文本的功能

        var drag_el = this.dragConfig.dragEl;
        var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.id);
        //新位置 - 旧位置 = 移动的值
        const moveX = e.pageX - this.zoomConfig.startX;
        //新位置 - 旧位置 = 移动的值
        const moveY = e.pageY - this.zoomConfig.startY;
        // console.log("moveX", moveX);

        let newWidth = 0;
        let newHeight = 0;
        var dir = this.zoomConfig.direction

        if (dir == "left" || dir == "left-top" || dir == "left-bottom") {
          //得出元素缩放后的新宽度
          newWidth = Number(drag_dom.width) + (moveX * -1);
          //得出元素缩放后的新位置
          let newX = Number(drag_dom.x) + moveX;
          drag_el.style.left = newX + 'px';
          drag_el.style.width = newWidth + "px";
        }

        if (dir == "top" || dir == "left-top" || dir == "right-top") {
          //得出元素缩放后的新高度
          newHeight = Number(drag_dom.height) + (moveY * -1);
          if (newHeight < 20) {
            newHeight = 20; //限制最小值
          } else {
            //得出元素缩放后的新位置
            let newY = Number(drag_dom.y) + moveY;
            drag_el.style.top = newY + 'px';
          }
          drag_el.style.height = newHeight + "px";
        }

        if (dir == "right" || dir == "right-top" || dir == "right-bottom") {
          //得出元素缩放后的新高度
          newWidth = Number(drag_dom.width) + moveX;
          drag_el.style.width = newWidth + "px";
        }

        if (dir == "bottom" || dir == "left-bottom" || dir == "right-bottom") {
          //得出元素缩放后的新高度
          newHeight = Number(drag_dom.height) + moveY;
          if (newHeight <= 20) newHeight = 20; //限制最小值
          drag_el.style.height = newHeight + "px";
        }
      }
    },
    //鼠标抬起
    onMouseUp(e) {
      // console.log("鼠标抬起", [e.target]);
      document.body.style.userSelect = ""; //重新打开鼠标选择文本的功能

      this.dragConfig.isdragging = false;
      this.dragConfig.mouse.x = 0;
      this.dragConfig.mouse.y = 0;

      let dir = this.zoomConfig.direction;

      //元素缩放相关代码
      if (dir != null) {
        var drag_el = this.dragConfig.dragEl;
        var drag_dom = this.dragConfig.dragDoms.find(x => x.domId == drag_el.id);
        if (dir == "left" || dir == "left-top" || dir == "left-bottom") {
          drag_dom.x = drag_dom.x - (drag_el.offsetWidth - drag_dom.width);
        }
        if (dir == "top" || dir == "left-top" || dir == "right-top") {
          drag_dom.y = drag_dom.y - (drag_el.offsetHeight - drag_dom.height);
        }
        drag_dom.height = drag_el.offsetHeight;
        drag_dom.width = drag_el.offsetWidth;
        this.zoomConfig.direction = null;
        this.zoomConfig.startY = 0;
        this.zoomConfig.startX = 0;
      }
    },
    //鼠标点击
    onMouseClick(e) {
      // console.log("鼠标点击", [e.target]);
      if (e.target.dataset.type == "field") {
        var parent = e.target.parentNode;
        // Array(...parent.children).forEach(x => x.className = "");
        Array(...parent.children).forEach(x => x.removeAttribute("class"));
        e.target.className = "is-select";

        var handle = document.getElementById("handle");
        handle.style.display = "block";
        e.target.appendChild(handle);
      }
    },
    getCustomData() {
      var handle = document.getElementById("handle");
      handle.style.display = "none";
      this.customBox.appendChild(handle);

      var children = this.customBox.children;
      Array(...children).forEach(x => x.removeAttribute("class"));

      var fields = Array(...children).filter(x => x.dataset.type == "field");
      var data = {
        htmlData: [],
        domData: []
      };
      fields.forEach(x => {
        data.htmlData.push(x.outerHTML);
        var dom = this.dragConfig.dragDoms.find(w => w.domId == x.id);
        dom.dataset = { ...x.dataset };
        Object.keys(dom.style).forEach(k => dom.style[k] = x.style[k]);
        data.domData.push(dom);
      })
      console.log("data", data);
      return data;
    },
    setCustomData(data) {
      this.dragConfig.dragDoms = [...data.domData];
      var html_str = "";
      data.htmlData.forEach(x => html_str += x);
      this.customBox.innerHTML = this.customBox.innerHTML + html_str;

      this.customBox.childNodes.forEach(dom => {
        if (dom.id != "handle") {
          dom.onclick = this.onMouseClick;
          dom.onmousedown = this.onMouseDown;
        }
      })
    },
    clear(reset = false) {
      var handle = document.getElementById("handle");
      handle.style.display = "none";
      this.customBox.appendChild(handle);
      var children = this.customBox.children;
      var fields = Array(...children).filter(x => x.dataset.type == "field");
      fields.forEach(x => this.customBox.removeChild(x))

      var initdata = this.$options.data();
      Object.assign(this.dragConfig, initdata.dragConfig);
      Object.assign(this.zoomConfig, initdata.zoomConfig);

      if (reset == false) {
        this.customBox = null;
        window.removeEventListener("mousemove", this.onMouseMove);
        window.removeEventListener("mouseup", this.onMouseUp);
      }
    }
  }
}
</script>
<style lang="scss">
#custom-box {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: 150px;
  background-color: #ffffff;
  border: 1px solid #E4E7ED;

  div {
    position: absolute;
    cursor: default;
  }

  .is-select {
    border-color: red !important;
  }

  #handle {
    position: absolute;
    width: 100%;
    height: 100%;
    top: 0;
    pointer-events: none;

    .point {
      width: 5px;
      height: 5px;
      border-radius: 50%;
      background-color: red;
      pointer-events: auto;
    }

    .left {
      position: absolute;
      left: -3px;
      top: 50%;
      transform: translateY(-50%);
      cursor: w-resize; //西
    }

    .left-top {
      position: absolute;
      left: -3px;
      top: -3px;
      cursor: nw-resize; //西北
    }

    .top {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: -3px;
      cursor: n-resize; //北
    }

    .right-top {
      position: absolute;
      top: -3px;
      right: -3px;
      cursor: ne-resize; //东北
    }

    .right {
      position: absolute;
      right: -3px;
      top: 50%;
      transform: translateY(-50%);
      cursor: e-resize; //东
    }

    .right-bottom {
      position: absolute;
      right: -3px;
      bottom: -3px;
      cursor: se-resize; //东南
    }

    .bottom {
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      bottom: -3px;
      cursor: s-resize; //南
    }

    .left-bottom {
      position: absolute;
      left: -3px;
      bottom: -3px;
      cursor: sw-resize; //西南
    }
  }
}
</style>